









import Component from 'vue-class-component';
import BackgroundColorMixin from '@/common/ts/background-color/BackgroundColorMixin';

const BackTopIcon = () => import('@/common/icons/arrow-right.svg');

@Component({
  components: {
    BackTopIcon,
  },
})
export default class BackTopButton extends BackgroundColorMixin {
  scrollTop () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
